<div class="leave-request container-fluid bg-light-gray p-0">
  <div class="row row-cols-1 gy-2 m-0">
    <div class="col bg-primary-white mt-0 navbar-spacer">
      <app-navbar class="fixed-top">
        <div class="px-2 py-1" (click)="showAddLeaveRequest()">
          <span class="fas fa-plus-circle text-secondary-purple fs-4"></span>
        </div>
      </app-navbar>
    </div>
    <div class="col bg-primary-white px-4" >
      <ul class="nav nav-justified">
        <li class="nav-item">
          <button
            id="leave-tab-all"
            class="nav-link active text-secondary pb-1"
            data-bs-toggle="tab"
            data-bs-target="#leaveRequestAll"
            type="button"
          >
            {{ 'app.leaveRequest.all' | translate }}
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link text-secondary pb-1"
            data-bs-toggle="tab"
            data-bs-target="#leaveRequestPending"
            type="button"
          >
            {{ 'app.leaveRequest.pending' | translate }}
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link text-secondary pb-1"
            id="messages-tab"
            data-bs-toggle="tab"
            data-bs-target="#leaveRequestApproved"
            type="button"
          >
            {{ 'app.leaveRequest.approved' | translate }}
          </button>
        </li>
      </ul>
      <div class="tab-content py-3">
        <div class="tab-pane active" id="leaveRequestAll">
          <ng-container
            [ngTemplateOutlet]="requestList"
            [ngTemplateOutletContext]="{ requests: leaveRequests() }"
          >
          </ng-container>
        </div>
        <div class="tab-pane" id="leaveRequestPending">
          <ng-container
            [ngTemplateOutlet]="requestList"
            [ngTemplateOutletContext]="{ requests: pendingRequests() }"
          >
          </ng-container>
        </div>
        <div class="tab-pane" id="leaveRequestApproved">
          <ng-container
            [ngTemplateOutlet]="requestList"
            [ngTemplateOutletContext]="{ requests: approvedRequests() }"
          >
          </ng-container>
        </div>
      </div>
      <ng-template #requestList let-requests="requests">
        @for (req of requests; track $index) {
          <div class="mt-3 mb-4">
            <div class="text-secondary pb-2">
              {{ req.applyDate | myDate }} -
              {{ 'app.leaveRequest.appliedDate' | translate }}
            </div>
            <div class="rounded shadow p-3">
              <div class="fs-4 text-secondary-purple">
                {{ req.clazz.date | myDate }}
              </div>
              <div class="fs-5 text-secondary">
                {{ req.clazz.date | myDate: true }}
              </div>
              <div class="border-top text-secondary my-2"></div>
              <div class="text-secondary-purple">
                @switch (req.clazz.type) {
                  @case ('Term Ride') {
                    {{ 'app.class.termRide' | translate }}
                  }
                  @case ('Independent Ride') {
                    {{ 'app.class.independentRide' | translate }}
                  }
                  @case ('Group Ride') {
                    {{ 'app.class.groupRide' | translate }}
                  }
                  @default {
                    {{ req.clazz.type }}
                  }
                }
              </div>
              <div class="fs-5">{{ req.clazz.venue }}</div>
              <div class="text-secondary">
                <span class="far fa-clock me-2"></span>
                <span>
                  {{ req.clazz.shortTimeStart() }} - {{ req.clazz.shortTimeEnd() }} · {{ req.clazz.getDuration() }}{{ 'app.leaveRequest.mins' | translate }}
                </span>
              </div>
              <div class="mt-3 text-light">
                @if (req.applyStatus === 'Approved') {
                  <span class="rounded-pill bg-secondary-purple p-1 px-2 me-2 fs-7">{{
                    'app.leaveRequest.approved' | translate
                  }}</span>
                }
                @if (req.applyStatus === 'Pending') {
                  <span class="rounded-pill bg-accent-orange p-1 px-2 me-2 fs-7">{{
                    'app.leaveRequest.pending' | translate
                  }}</span>
                }
                @let leaveType = req.leaveType.toLowerCase();
                <span class="rounded-pill bg-secondary p-1 px-2 me-2 fs-7">{{
                  `app.leaveRequest.leaveType.${leaveType}` | translate
                }}</span>
              </div>
            </div>
          </div>
        } @empty {
          <div class="ratio ratio-1x1">
            <div class="d-grid align-items-center justify-content-center">
              @if (isDataLoading) {
                <div class="spinner-border text-secondary-purple"></div>
              } @else {
                <span>{{ 'app.leaveRequest.noAnyRecords' | translate }}</span>
              }
            </div>
          </div>
        }
      </ng-template>
    </div>
  </div>
  @defer {
    <add-leave-request
      (addRequestCallback)="addRequestCallback($event)"
    ></add-leave-request>
  }
</div>
